export default {
    authorizarionId: 'string',
    dashboardId: 'string',
    token: 'string',
}
